export default "__VITE_ASSET__DR4SKRO4__"